import React, { Component } from "react";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "normalize.css/normalize.css";
import "../../App.css";

const content = [
  {
    title: "",
    description: "",
    image: "https://i.imgur.com/xXawzS3.jpg",
    user: "Ari",
    userProfile:
      "https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-9/124018462_10166244566025206_6009812945501845709_n.jpg?_nc_cat=101&ccb=2&_nc_sid=09cbfe&_nc_ohc=VagIU1sbUVAAX-8A2UM&_nc_ht=scontent-bos3-1.xx&oh=a9a774c6d6eef0c075dc12051c521ff4&oe=5FDC7E01",
  },
  {
    title: "Birthday Cakes",
    description: "",
    image: "https://i.imgur.com/dtjMeh4.jpg",
    user: "Ari",
    userProfile:
      "https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-9/107715235_10165700433165206_307273789240547947_n.jpg?_nc_cat=103&_nc_sid=09cbfe&_nc_ohc=8625fUYP0B8AX-yq00s&_nc_ht=scontent-bos3-1.xx&oh=2b6ff4a45b402f911a8cf4757026d7b8&oe=5F99C36C",
  },
  {
    title: "Cake Cups",
    description: "",
    image: "https://i.imgur.com/TsqWwCA.jpg",
    user: "Ari",
    userProfile:
      "https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-9/124018462_10166244566025206_6009812945501845709_n.jpg?_nc_cat=101&ccb=2&_nc_sid=09cbfe&_nc_ohc=VagIU1sbUVAAX-8A2UM&_nc_ht=scontent-bos3-1.xx&oh=a9a774c6d6eef0c075dc12051c521ff4&oe=5FDC7E01",
  },
  {
    title: "",
    description: "",
    image: "https://i.imgur.com/nK3aOJ6.jpg",
    user: "Ari",
    userProfile:
      "https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-9/124018462_10166244566025206_6009812945501845709_n.jpg?_nc_cat=101&ccb=2&_nc_sid=09cbfe&_nc_ohc=VagIU1sbUVAAX-8A2UM&_nc_ht=scontent-bos3-1.xx&oh=a9a774c6d6eef0c075dc12051c521ff4&oe=5FDC7E01",
  },
  {
    title: "",
    description: "",
    image:
      "https://i.imgur.com/oi2agsg.jpg",
    user: "Ari",
    userProfile:
      "https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-9/124018462_10166244566025206_6009812945501845709_n.jpg?_nc_cat=101&ccb=2&_nc_sid=09cbfe&_nc_ohc=VagIU1sbUVAAX-8A2UM&_nc_ht=scontent-bos3-1.xx&oh=a9a774c6d6eef0c075dc12051c521ff4&oe=5FDC7E01",
  },
];

class SliderGlide extends Component {
  render() {
    return (
      <div>
        <Slider className="slider-wrapper" autoplay={8000}>
          {content.map((item, index) => (
            <div
              key={index}
              className="slider-content"
              style={{
                background: `url('${item.image}') no-repeat center center`,
              }}
            >
              <div className="inner">
                <h1>{item.title}</h1>
                <p>{item.description}</p>
              </div>
              <section>
                <img src={item.userProfile} alt={item.user} />
                <span>
                  Posted by <strong>{item.user}</strong>
                </span>
              </section>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}
export default SliderGlide;
